export const csaSortPropertyMap = {
  createdAt: 'CREATED_AT',
  updateDatetime: 'UPDATE_DATETIME',
  deaRetdt: 'DEA_RETDT',
  deaExpdt: 'DEA_EXPDT',
  status: 'STATUS',
  registrantLastNameBussName: 'REGISTRANT_LAST_NAME_BUSS_NAME',
  registrantFirstName: 'REGISTRANT_FIRST_NAME',
  registrantPocEmail: 'REGISTRANT_POC_EMAIL',
  actionBy: 'ACTION_BY',
};
